module.exports = __webpack_public_path__ + "static/media/login_salim.10d50aa9.png";